import { useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "../../modal/Modal";
import { useBenchmarkingDisclaimerManager } from "./BenchmarkingDisclaimerTrigger.functions";

import "./BenchmarkingDisclaimerTrigger.css";

/// props validation | SQ(javascript:S6774)
BenchmarkingDisclaimerTrigger.propTypes = {
  auth: PropTypes.object,
};
///
export default function BenchmarkingDisclaimerTrigger(props) {
  const { user } = props.auth;
  const [manager] = useBenchmarkingDisclaimerManager({ user });

  const { disclaimerAccepted, setShow } = manager;

  useEffect(() => {
    if (!disclaimerAccepted) {
      setShow(true);
    }
  }, [disclaimerAccepted, setShow]);

  return (
    <div className="benchmarking-disclaimer-trigger">
      <ButtonWithModal {...manager} />
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
ButtonWithModal.propTypes = {
  buttonLabel: PropTypes.any,
  buttonClassName: PropTypes.string,
  onClick: PropTypes.func,
  ModalComponent: PropTypes.func,
  label: PropTypes.any,
  show: PropTypes.bool,
  setShow: PropTypes.func,
};
///
export function ButtonWithModal(props) {
  const { buttonLabel, buttonClassName, onClick } = props;
  const { label, ModalComponent, show, setShow } = props;

  return (
    <>
      <button className={buttonClassName} onClick={onClick}>
        {buttonLabel}
      </button>
      <Modal
        Component={ModalComponent}
        modal={show}
        setModal={setShow}
        title={label}
        {...props}
      />
    </>
  );
}
